module.exports = __webpack_public_path__ + "img/error-dark.03eef8dd.svg";